export default __webpack_public_path__ + "b9568839eae67d5eef22e9693513a1ad.png";